import { __extends } from "tslib";
import React from 'react';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';
var FullscreenShareButtons = /** @class */ (function (_super) {
    __extends(FullscreenShareButtons, _super);
    function FullscreenShareButtons(props) {
        var _this = _super.call(this, props) || this;
        _this.buttons = [];
        return _this;
    }
    FullscreenShareButtons.prototype.componentDidUpdate = function () {
        try {
            var focusedButton = this.props.focus;
            if (focusedButton > 0) {
                this.buttons[focusedButton - 1].focus();
            }
        }
        catch (e) {
            console.warn('Cannot focus on share icon', this.props.focus, e);
        }
    };
    FullscreenShareButtons.prototype.createSingleShareButton = function (shareArr, network, idx) {
        var _this = this;
        return (React.createElement("li", { key: idx, role: "menuitem" },
            React.createElement("button", { className: 'fullscreen-social-' +
                    network +
                    ' progallery-svg-font-icons-' +
                    network +
                    ' has-custom-focus', ref: function (button) { return (_this.buttons[idx] = button); }, onClick: function () {
                    var shareData = {
                        network: network,
                        shareProps: _this.props.item,
                    };
                    _this.props.actions.eventsListener(FULLSCREEN_EVENTS.SHARE_BUTTON_CLICKED, shareData);
                }, key: network + '-share-icon', "data-hook": network + '-share-hook', title: "Share on ".concat(network), tabIndex: -1 })));
    };
    FullscreenShareButtons.prototype.render = function () {
        var _this = this;
        var shareArr = ['facebook', 'twitter', 'pinterest', 'tumblr', 'email'];
        if (this.props.item.type === 'text') {
            shareArr.splice(2, 1);
        }
        return (React.createElement("div", null,
            React.createElement("ul", { className: "fullscreen-social-items-container", "aria-hidden": this.props.ariaHidden !== 'undefined'
                    ? this.props.ariaHidden
                    : false, role: "menu" }, shareArr.map(function (network, idx) {
                return _this.createSingleShareButton(shareArr, network, idx);
            }))));
    };
    return FullscreenShareButtons;
}(React.Component));
export default FullscreenShareButtons;
//# sourceMappingURL=fullscreenShareButtons.js.map